import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { pulseCheckTheme } from '../../PulseCheck.meta';
import { Wrapper } from './PulseCheckTopNav.styles';
import LogoText from '../../img/logo-text.svg';

interface Props {
  clientId: string;
}

export const PulseCheckTopNav = ({ clientId }: Props) => {
  return (
    <ThemeProvider theme={pulseCheckTheme}>
      <Wrapper py="12" px="24">
        <Button
          variant="subtleActive"
          onClick={() => ADV.util.Router.go2('PulseCheckResults', { clientId })}
          leftIcon="fas fa-chevron-left"
        >
          Back to PulseCheck Results
        </Button>

        <LogoText width={118} height={16} />
      </Wrapper>
    </ThemeProvider>
  );
};
